import {IS_USING_MAINNET} from "../../constants";
import {ANALYTICS_API_URLS} from "./tinymanAnalyticsApiConstants";

function getAnalyticsApiBaseURLForNetwork() {
  return IS_USING_MAINNET ? ANALYTICS_API_URLS.mainnet : ANALYTICS_API_URLS.testnet;
}

export {getAnalyticsApiBaseURLForNetwork};
